"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
exports.search = search;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _utils = require("./utils");

var _algoliaService = require("@insided/deprecated-services/algoliaService");

var _algolia = require("@insided/shared/services/algolia");

var _utils2 = require("@insided/destination/modules/Search/utils");

var _common = require("@insided/shared/utils/common");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Content type mapping (user-friendly -> Algolia field names)
 * Maps SDK-friendly content type names to Algolia index field values
 */
var CONTENT_TYPE_MAP = {
  idea: 'ideation',
  ideation: 'ideation',
  article: 'article',
  question: 'question',
  discussion: 'discussion',
  conversation: 'discussion',
  // conversation maps to 'discussion' in Algolia
  event: 'event',
  productUpdate: 'productUpdate'
};
/**
 * Get Algolia search credentials
 */

function getCredentials() {
  return _getCredentials.apply(this, arguments);
}
/**
 * Map content types to Algolia format
 */


function _getCredentials() {
  _getCredentials = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              (0, _algoliaService.getSearchToken)(function (creds) {
                resolve(creds);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCredentials.apply(this, arguments);
}

function mapContentTypesToAlgolia(contentType) {
  var contentTypes = Array.isArray(contentType) ? contentType : [contentType];
  return contentTypes.map(function (ct) {
    return CONTENT_TYPE_MAP[ct] || ct;
  });
}
/**
 * Get included data sources for federated search
 * Used by getFilters for unified index filtering
 * Matches the data sources used by Search.tsx and InstantSearch.tsx
 */


function getIncludedDataSources(credentials) {
  var dataSources = []; // Check each federated search integration
  // These module flags are set in modules.json based on community configuration

  if (_common.common.isModuleActive('skilljarFederatedSearch')) {
    dataSources.push('skilljar');
  }

  if (_common.common.isModuleActive('salesforceFederatedSearch')) {
    dataSources.push('salesforce');
  }

  if (_common.common.isModuleActive('freshdeskFederatedSearch')) {
    dataSources.push('freshdesk');
  }

  if (credentials.isZendeskFederatedSearchEnabled) {
    dataSources.push('zendesk');
  }

  if (_common.common.isModuleActive('federatedSearchApi')) {
    dataSources.push('federated');
  }

  return dataSources;
}
/**
 * Fetch topic metadata from the backend using the same endpoint as Search.tsx
 * Reuses the SearchService pattern from @insided/destination/modules/Search/services/SearchService
 *
 * @param topicIds - Array of topic IDs to fetch metadata for
 * @returns Promise resolving to a map of topic ID -> TopicInfo
 */


function fetchTopicsMetadata(_x) {
  return _fetchTopicsMetadata.apply(this, arguments);
}
/**
 * Perform a search using Algolia with simplified options
 * Follows the same pattern as Search.tsx and SearchService.tsx for consistency
 *
 * @param options - Search options including query, contentType filter, limit, and fetchMetadata
 * @returns Promise resolving to an array of search results (enriched with metadata by default)
 * @throws Error if the search fails
 *
 * @example
 * // Basic search with metadata enrichment (default)
 * const results = await search({ query: 'help with login' })
 *
 * @example
 * // Search without metadata (faster, basic data only)
 * const results = await search({ query: 'help', fetchMetadata: false })
 *
 * @example
 * // Filter by content type with metadata
 * const ideas = await search({ query: 'feature request', contentType: 'idea' })
 */


function _fetchTopicsMetadata() {
  _fetchTopicsMetadata = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(topicIds) {
    var metadataMap, response, _iterator, _step, topic;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            metadataMap = new Map();

            if (!(topicIds.length === 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", metadataMap);

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return _axios.default.get('/search/getTopics', {
              params: {
                topicIds: topicIds
              }
            });

          case 6:
            response = _context2.sent;

            if (response.data && Array.isArray(response.data)) {
              _iterator = _createForOfIteratorHelper(response.data);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  topic = _step.value;
                  metadataMap.set(topic.id, topic);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }

            _context2.next = 13;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            console.error('Error fetching topic metadata:', _context2.t0); // Don't throw - return empty map so search still works with basic data

          case 13:
            return _context2.abrupt("return", metadataMap);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 10]]);
  }));
  return _fetchTopicsMetadata.apply(this, arguments);
}

function search(_x2) {
  return _search.apply(this, arguments);
} // Export Search API object


function _search() {
  _search = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(options) {
    var query, contentType, _options$limit, limit, _options$page, page, _options$fetchMetadat, fetchMetadata, categoryName, categoryIds, kbCategoryName, productAreaName, customFacetFilters, communityId, _searchResponse$resul, credentials, searchClient, algoliaContentTypes, includedDataSources, filters, params, builtFacetFilters, searchResponse, hits, topicIds, metadataMap;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context3.next = 2;
              break;
            }

            throw new Error('search can only be called in a browser environment');

          case 2:
            query = options.query, contentType = options.contentType, _options$limit = options.limit, limit = _options$limit === void 0 ? 30 : _options$limit, _options$page = options.page, page = _options$page === void 0 ? 0 : _options$page, _options$fetchMetadat = options.fetchMetadata, fetchMetadata = _options$fetchMetadat === void 0 ? true : _options$fetchMetadat, categoryName = options.categoryName, categoryIds = options.categoryIds, kbCategoryName = options.kbCategoryName, productAreaName = options.productAreaName, customFacetFilters = options.facetFilters;

            if (query) {
              _context3.next = 5;
              break;
            }

            throw new Error('Search query is required');

          case 5:
            communityId = (0, _utils2.getCommunityId)();

            if (communityId) {
              _context3.next = 8;
              break;
            }

            throw new Error('Community ID not found. The SDK must be initialized after globals are set.');

          case 8:
            _context3.prev = 8;
            _context3.next = 11;
            return getCredentials();

          case 11:
            credentials = _context3.sent;
            _context3.next = 14;
            return (0, _algolia.createAlgoliaClient)(credentials.client_id, credentials.token);

          case 14:
            searchClient = _context3.sent;
            // Map user-friendly content types to Algolia format
            algoliaContentTypes = contentType ? mapContentTypesToAlgolia(contentType) : undefined; // Get included data sources for federated search (used by getFilters for unified index)

            includedDataSources = getIncludedDataSources(credentials); // Use shared getFilters utility (same logic as Search.tsx component)
            // This handles content type filtering, unified index data source filtering, etc.
            // categoryIds → searchInContentCategories → forum:1 OR forum:2 in the filters string

            filters = (0, _utils2.getFilters)({
              searchByContentType: algoliaContentTypes,
              searchInContentCategories: categoryIds !== null && categoryIds !== void 0 && categoryIds.length ? categoryIds : undefined,
              hiddenCategories: credentials.hiddenCategories,
              isControl: false
            }, includedDataSources);
            params = {
              hitsPerPage: limit,
              page: page,
              // 0-indexed pagination (matches UI behavior)
              facetingAfterDistinct: true,
              // Match UI behavior for consistent result ordering
              restrictSearchableAttributes: (0, _utils2.getRestrictedSearchableAttributes)(),
              clickAnalytics: true,
              analyticsTags: ['destination', 'ch-web-sdk']
            }; // Only add filters if they're not empty

            if (filters) {
              params.filters = filters;
            } // Build facetFilters for hierarchical category filters (same as global search page)
            // categories.lvl0 = community category name, kb.categories.lvl0 = KB category, product_area.lvl0 = product area


            builtFacetFilters = (0, _toConsumableArray2.default)(customFacetFilters !== null && customFacetFilters !== void 0 ? customFacetFilters : []);

            if (categoryName) {
              builtFacetFilters.push(["categories.lvl0:".concat(categoryName)]);
            }

            if (kbCategoryName) {
              builtFacetFilters.push(["kb.categories.lvl0:".concat(kbCategoryName)]);
            }

            if (productAreaName) {
              builtFacetFilters.push(["product_area.lvl0:".concat(productAreaName)]);
            }

            if (builtFacetFilters.length > 0) {
              params.facetFilters = builtFacetFilters;
            }

            _context3.next = 27;
            return searchClient.search([{
              indexName: communityId,
              query: query,
              params: params
            }]);

          case 27:
            searchResponse = _context3.sent;
            hits = ((_searchResponse$resul = searchResponse.results[0]) === null || _searchResponse$resul === void 0 ? void 0 : _searchResponse$resul.hits) || []; // If fetchMetadata is disabled, return basic results using shared utility

            if (fetchMetadata) {
              _context3.next = 31;
              break;
            }

            return _context3.abrupt("return", (0, _utils2.transformHits)(hits));

          case 31:
            // Extract topic IDs for metadata fetch using shared utility
            topicIds = (0, _utils2.extractTopicIds)(hits); // Fetch metadata from backend (same endpoint as SearchService.fetchMetadataForTopics)

            _context3.next = 34;
            return fetchTopicsMetadata(topicIds);

          case 34:
            metadataMap = _context3.sent;
            return _context3.abrupt("return", (0, _utils2.mergeHitsWithMetadata)(hits, metadataMap));

          case 38:
            _context3.prev = 38;
            _context3.t0 = _context3["catch"](8);
            console.error('Error performing search:', _context3.t0);
            throw _context3.t0;

          case 42:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[8, 38]]);
  }));
  return _search.apply(this, arguments);
}

var Search = {
  search: search
};
exports.Search = Search;